import type { ValueOf } from 'type-fest';

import { Match } from 'effect';

export const Warehouse = {
  KAVAN: 'KAVAN',
  ASTRA: 'ASTRA',
  CONQUEST: 'CONQUEST',
  DVEDETI: 'DVEDETI',
  CARMODEL: 'CARMODEL',
  CORFIX: 'CORFIX',
  HOREJSI: 'HOREJSI',
  RCSALE: 'RCSALE',
  PROMODELS: 'PROMODELS',
  MPM: 'MPM',
  AMEWI: 'AMEWI',
  PCE: 'PCE',
  CRU: 'CRU',
} as const;

export type WarehouseT = ValueOf<typeof Warehouse>;

// TODO. intl
export function intlWarehouse(type: WarehouseT) {
  return Match.value(type).pipe(
    Match.when(Warehouse.KAVAN, () => 'Kavan'),
    Match.when(Warehouse.ASTRA, () => 'Astra'),
    Match.when(Warehouse.CONQUEST, () => 'Conquest'),
    Match.when(Warehouse.DVEDETI, () => 'Dvědětí'),
    Match.when(Warehouse.CARMODEL, () => 'Carmodel'),
    Match.when(Warehouse.CORFIX, () => 'Corfix'),
    Match.when(Warehouse.HOREJSI, () => 'Horejší'),
    Match.when(Warehouse.RCSALE, () => 'RC Sale'),
    Match.when(Warehouse.PROMODELS, () => 'Promodels'),
    Match.when(Warehouse.MPM, () => 'MPM'),
    Match.when(Warehouse.AMEWI, () => 'AMEWI'),
    Match.when(Warehouse.PCE, () => 'Prodejna Pardubice'),
    Match.when(Warehouse.CRU, () => 'Prodejna Chrudim'),
    Match.exhaustive
  );
}
